import React, { useEffect, useState } from 'react';
import * as d3 from 'd3';
import worldGeoJson from '../utils/customGeoJson.json';
import './css/Visualization1.css';

function GdpShare() {
  const [year, setYear] = useState(2022);

  useEffect(() => {
    // Load CSV data
    d3.csv(`${process.env.PUBLIC_URL}/data/tourism-gdp-proportion-of-total-gdp.csv`).then((loadedData) => {
      const parsedData = loadedData.map(d => ({
        country: d.Entity,
        code: d.Code,
        year: +d.Year,
        gdp_share: +d['GDP-share'],
      }));

      const yearData = parsedData.filter(d => d.year === year);
      drawMap(yearData);
      createLegend();
    });
  }, [year]);

  const drawMap = (yearData) => {
    // Clear previous SVG
    d3.select("#map").selectAll("*").remove();

    const svgWidth = 800;
    const svgHeight = 550;
    const svg = d3.select("#map")
      .append("svg")
      .attr("width", svgWidth)
      .attr("height", svgHeight);

    const projection = d3.geoMercator()
      .scale(130)
      .translate([svgWidth / 2, svgHeight / 2]);

    const path = d3.geoPath().projection(projection);

    // Use schemeRdPu for color scale
    const colorScale = d3.scaleThreshold()
      .domain([0, 1, 2, 3, 4, 5, 6])
      .range(d3.schemeBuGn[7]);

    const opacityScale = d3.scaleLinear()
      .domain([0, 7])
      .range([0.3, 1]);

    const tooltip = d3.select("body").append("div")
      .attr("class", "tooltip")
      .style("position", "absolute")
      .style("opacity", 0)
      .style("background", "white")
      .style("border", "1px solid black")
      .style("padding", "5px");

    svg.append("g")
      .selectAll("path")
      .data(worldGeoJson.features)
      .enter()
      .append("path")
      .attr("d", path)
      .attr("fill", d => {
        const countryData = yearData.find(country => country.code === d.properties.adm0_a3);
        return countryData ? colorScale(countryData.gdp_share) : "#ccc";
      })
      .style("opacity", d => {
        const countryData = yearData.find(country => country.code === d.properties.adm0_a3);
        return countryData ? opacityScale(countryData.gdp_share) : 0.1;
      })
      .attr("stroke", "#2e2c2c")
      .attr("stroke-width", 0.5)
      .on("mouseover", (event, d) => {
        const countryData = yearData.find(country => country.code === d.properties.adm0_a3);
        tooltip.transition().duration(200).style("opacity", 0.9);
        tooltip.html(`${d.properties.name}: ${countryData ? countryData.gdp_share.toFixed(2) + '%' : "No data"}`)
          .style("left", (event.pageX + 5) + "px")
          .style("top", (event.pageY - 28) + "px");
      })
      .on("mouseout", () => {
        tooltip.transition().duration(500).style("opacity", 0);
      });
  };

  const createLegend = () => {
    const legendContainer = d3.select("#legend-container");
    legendContainer.html(""); // Clear previous content

    // "No data" section
    legendContainer.append("div")
      .attr("class", "legend-item")
      .style("display", "inline-block")
      .style("margin-right", "10px")
      .html('<div style="width: 30px; height: 15px; background-color: #ccc; display: inline-block; border: 1px solid black;"></div> No data');

    // Color scale legend
    const legendData = [0, 1, 2, 3, 4, 5, 6];
    const legendColors = d3.schemeBuGn[7];

    legendData.forEach((value, i) => {
      legendContainer.append("div")
        .attr("class", "legend-item")
        .style("display", "inline-block")
        .style("margin-right", "10px")
        .html(`
          <div style="width: 30px; height: 15px; background-color: ${legendColors[i]}; display: inline-block; border: 1px solid black;"></div>
          ${i === legendData.length - 1 ? `${value}%+` : `${value}%`}
        `);
    });
  };

  return (
    <div>
      <div className="header-container">
        <h2>
          Choropleth Map of Tourism GDP as a Proportion of Total GDP
        </h2>
        <p>
          Percentage of GDP contributed by tourism for each country.
        </p>
      </div>
      <div id="map"></div>
      <div id="legend-container"></div>
      <input
        type="range"
        min="2008"
        max="2022"
        value={year}
        onChange={e => setYear(+e.target.value)}
      />
      <div className="slider-label">{year}</div>
    </div>
  );
}

export default GdpShare;